const toNumber = (value) => {
  const normalized = String(value || "").replace(",", ".").trim();
  if (!normalized) return 0;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : 0;
};

const hasText = (value) => String(value ?? "").trim() !== "";
const isClasseSucata = (value) => String(value ?? "").trim().toUpperCase() === "SUCATA";
const isRecebimentoGeracaoSelected = (value) => {
  const normalized = String(value ?? "").trim().toUpperCase();
  return normalized === "SIM" || normalized === "NÃO" || normalized === "NAO";
};

export const rowHasAnyDataReemprego = (row = {}) =>
  Boolean(hasText(row.perfil) || hasText(row.metragem) || hasText(row.classe) || hasText(row.motivoSucata));

const buildValidationResult = ({ formErrors = [], rowErrors = [], emptyMessage = "" }) => {
  const modalGroups = [];

  if (emptyMessage) {
    modalGroups.push({
      id: "sem-informacao",
      title: "Ficha",
      errors: [emptyMessage],
    });
  } else {
    if (formErrors.length) {
      modalGroups.push({
        id: "dados-ficha",
        title: "Dados da ficha",
        errors: formErrors,
      });
    }

    rowErrors.forEach((rowGroup) => {
      modalGroups.push({
        id: `linha-${rowGroup.line}`,
        title: rowGroup.label,
        errors: rowGroup.errors,
      });
    });
  }

  const flatErrors = emptyMessage
    ? [emptyMessage]
    : [
        ...formErrors,
        ...rowErrors.flatMap((rowGroup) => rowGroup.errors.map((error) => `${rowGroup.label}: ${error}`)),
      ];

  return {
    isValid: flatErrors.length === 0,
    firstError: flatErrors[0] || "",
    flatErrors,
    modalGroups,
    totalErrors: flatErrors.length,
  };
};

export function validateCadastroTrilhosReemprego({ form = {}, rows = [] }) {
  const safeRows = Array.isArray(rows) ? rows : [];
  const hasAnyRowData = safeRows.some((row) => rowHasAnyDataReemprego(row));

  if (!hasAnyRowData) {
    return buildValidationResult({
      emptyMessage: "Nenhuma informação preenchida na tabela.",
    });
  }

  const formErrors = [];
  const rowErrors = [];

  if (!hasText(form.data)) formErrors.push("Data: preenchimento obrigatório.");
  if (!hasText(form.origemCarregamento)) formErrors.push("Origem do carregamento: preenchimento obrigatório.");
  if (!isRecebimentoGeracaoSelected(form.recebimentoGeracao)) {
    formErrors.push("Recebimento de geração: selecione Sim ou Não.");
  }
  if (!hasText(form.numeroNf)) formErrors.push("Nº NF: preenchimento obrigatório.");
  if (!hasText(form.carreta)) formErrors.push("Carreta: preenchimento obrigatório.");
  if (!hasText(form.cavalo)) formErrors.push("Cavalo: preenchimento obrigatório.");

  safeRows.forEach((row) => {
    if (!rowHasAnyDataReemprego(row)) return;

    const line = Number(row?.id) || 0;
    const label = line > 0 ? `Linha ${line}` : "Linha";
    const currentRowErrors = [];
    const perfil = String(row?.perfil || "").trim();
    const metragemRaw = String(row?.metragem || "").trim();
    const classe = String(row?.classe || "").trim();
    const motivoSucata = String(row?.motivoSucata || "").trim();
    const metragem = toNumber(metragemRaw);

    if (!perfil) currentRowErrors.push("Perfil é obrigatório.");
    if (!metragemRaw || metragem <= 0) currentRowErrors.push("Metragem é obrigatória.");
    if (!classe) currentRowErrors.push("Classe dos trilhos é obrigatória.");
    if (isClasseSucata(classe) && !motivoSucata) {
      currentRowErrors.push("Ao informar classe Sucata, o Motivo da sucata é obrigatório.");
    }

    if (currentRowErrors.length) {
      rowErrors.push({
        line,
        label,
        errors: currentRowErrors,
      });
    }
  });

  return buildValidationResult({ formErrors, rowErrors });
}
